import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import Icon, { ICON_SIZE_REGULAR } from '@divvy-web/skylab.icon'

import styles from './styles.module.scss'

const TilaErrorMessage = () => {
  const [getClassName] = useNameFormatter('TilaErrorMessage')
  return (
    <div className={styles[getClassName('')]}>
      <Icon
        name='feedbackInfo'
        size={ICON_SIZE_REGULAR}
      />
      <FormattedMessage
        defaultMessage='We are still waiting on more information to compile your offer agreement. Refresh browser or check back in a minute or two.'
        id='sputnik.TilaErrorMessage__gXbSwO'
      />
    </div>
  )
}

export default TilaErrorMessage
